import type { LoginMethodPayload } from '@modules/auth-helpers';
import { useCallback, useMemo, useState } from 'react';

import type { FavouredEmail, LoginFormProps } from './types';

export function useLoginForm(presetEmail?: string): Omit<LoginFormProps, 'onLogin'> {
  const [email, setEmail] = useState(presetEmail || '');
  const [password, setPassword] = useState('');
  const [loginFormMode, setLoginFormMode] = useState<'login' | 'reset'>('login');

  const [enteredPersonalEmail, setEnteredPersonalEmail] = useState<boolean>(false);
  const [favouredEmail, setFavouredEmail] = useState<FavouredEmail>();

  const [authProfile, setAuthProfile] = useState<LoginMethodPayload>({
    methodId: null,
    ssoEnforced: false,
    publicEmailAddress: false,
    isExistingUser: false,
    type: 'otp_signin',
  });

  const onShowLogin = useCallback(() => {
    setLoginFormMode('login');
  }, []);

  const onShowReset = useCallback(() => {
    setLoginFormMode('reset');
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: historic
  const signupFormProps: Omit<LoginFormProps, 'onLogin'> = useMemo(() => {
    return {
      email,
      onEmailChange: setEmail,
      password,
      onPasswordChange: setPassword,
      mode: loginFormMode,
      onShowLogin,
      onShowReset,
      authProfile,
      setAuthProfile,
      enteredPersonalEmail,
      setEnteredPersonalEmail,
      favouredEmail,
      setFavouredEmail,
    };
  }, [
    email,
    setEmail,
    password,
    setPassword,
    loginFormMode,
    onShowLogin,
    onShowReset,
    authProfile,
    setAuthProfile,
    enteredPersonalEmail,
    setEnteredPersonalEmail,
    favouredEmail,
    setFavouredEmail,
  ]);

  return signupFormProps;
}
